import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { APPOINTMENT_CLIENT_LOOKUP_REPOSITORY } from '../domain/repositories/appointment-client-lookup.repository';
import { APPOINTMENT_PATIENT_SPECIES_LOOKUP_REPOSITORY } from '../domain/repositories/appointment-patient-species-lookup.repository';
import { APPOINTMENT_REQUESTS_REPOSITORY } from '../domain/repositories/appointment-requests.repository';
import { APPOINTMENTS_REPOSITORY } from '../domain/repositories/appointments.repository';
import { AppointmentClientLookupRemoteDatasource } from './datasources/remote/appointment-client-lookup.remote-datasource';
import { AppointmentPatientSpeciesLookupRemoteDatasource } from './datasources/remote/appointment-patient-species-lookup.remote-datasource';
import { AppointmentRequestsRemoteDatasource } from './datasources/remote/appointment-requests.remote-datasource';
import { AppointmentsRemoteDatasource } from './datasources/remote/appointments.remote-datasource';
import { AppointmentRequestMapper } from './mappers/appointment-request.mapper';
import { AppointmentMapper } from './mappers/appointment.mapper';
import { ClientRefMapper } from './mappers/client-ref.mapper';
import { AppointmentClientLookupRepositoryImpl } from './repositories/appointment-client-lookup.repository.impl';
import { AppointmentPatientSpeciesLookupRepositoryImpl } from './repositories/appointment-patient-species-lookup.repository.impl';
import { AppointmentRequestsRepositoryImpl } from './repositories/appointment-requests.repository.impl';
import { AppointmentsRepositoryImpl } from './repositories/appointments.repository.impl';

export function provideAppointmentsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AppointmentsRemoteDatasource,
    AppointmentRequestsRemoteDatasource,
    AppointmentClientLookupRemoteDatasource,
    AppointmentPatientSpeciesLookupRemoteDatasource,
    AppointmentMapper,
    AppointmentRequestMapper,
    ClientRefMapper,
    { provide: APPOINTMENTS_REPOSITORY, useClass: AppointmentsRepositoryImpl },
    { provide: APPOINTMENT_REQUESTS_REPOSITORY, useClass: AppointmentRequestsRepositoryImpl },
    { provide: APPOINTMENT_CLIENT_LOOKUP_REPOSITORY, useClass: AppointmentClientLookupRepositoryImpl },
    { provide: APPOINTMENT_PATIENT_SPECIES_LOOKUP_REPOSITORY, useClass: AppointmentPatientSpeciesLookupRepositoryImpl },
  ]);
}
